var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 8.00008H4.6665M8.6665 10.6667H4.6665M3.6665 13.3334H12.3332C12.5984 13.3334 12.8527 13.2281 13.0403 13.0405C13.2278 12.853 13.3332 12.5986 13.3332 12.3334V5.49075C13.3331 5.38728 13.3089 5.28525 13.2625 5.19275L12.3685 3.40408C12.2577 3.18244 12.0874 2.99604 11.8766 2.8658C11.6659 2.73556 11.4229 2.66663 11.1752 2.66675H4.8245C4.57684 2.66676 4.33408 2.73574 4.12342 2.86598C3.91276 2.99621 3.74254 3.18254 3.63184 3.40408L2.73717 5.19275C2.69081 5.28525 2.66661 5.38728 2.6665 5.49075V12.3334C2.6665 12.5986 2.77186 12.853 2.9594 13.0405C3.14693 13.2281 3.40129 13.3334 3.6665 13.3334Z",
    stroke: "#BC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 5.3335H12.6663",
    stroke: "#BC0000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 7.3335H9.66634C9.48225 7.3335 9.33301 7.48273 9.33301 7.66683V9.00016C9.33301 9.18426 9.48225 9.3335 9.66634 9.3335H10.9997C11.1838 9.3335 11.333 9.18426 11.333 9.00016V7.66683C11.333 7.48273 11.1838 7.3335 10.9997 7.3335Z",
    fill: "#BC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete_red.6ca61f6e522133e438f4907d4058533d.svg";
export { ForwardRef as ReactComponent };